import React, { useContext, useState, useEffect } from "react";

//MUI
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";

//MUI Icons
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { Clip } from "../ObjectAnalysisImage";

//Custom
import imgService from "@/services/imgService";
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";

//Types
import { DCRecord } from "@/@types/lib/dataController";

export type QualityControlImageCropProps = {
  ordinal: number;
  selectedRecord: DCRecord | null;
}

const QualityControlImageCrop = (props: QualityControlImageCropProps) => {

  const [b64, setB64] = useState<string>('');

  const { ordinal, selectedRecord } = props;

  const baseRecordId = selectedRecord ? selectedRecord.id as number : null;

  useEffect(() => {
    setB64("")
    if (selectedRecord && baseRecordId) {
      loadCrop();
    }
  }, [baseRecordId]);

  const loadCrop = () => {
    if (selectedRecord && baseRecordId && ordinal) {
      const photoId = ordinal === 1 ? selectedRecord.foto_1 as number : ordinal === 2 ? selectedRecord.foto_2 as number : null;
      const clipText = ordinal === 1 ? selectedRecord.foto_1_extent as string : ordinal === 2 ? selectedRecord.foto_2_extent as string : null;
      if (photoId && clipText) {
        const clip = clipText.split(',').map(x => parseInt(x, 10)) as Clip;
        imgService.getRecordCrop(baseRecordId, photoId, clip)
          .then((resp) => {
            if (resp.data.image) {
              setB64(resp.data.image);
            }
          })
      } else {
        setB64("");
      }
    }
  }

  return (
    (<Box sx={{
      width: 200,
      height: 200,
      borderStyle: "solid",
      borderColor: "primary.light",
      borderWidth: 2,
      margin: "auto",
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      {!b64 ?
        <Typography fontSize={40} color="#CCC">{ordinal}</Typography>
        : null}
      {b64 ?
        <img
          src={`data:image/jpg;base64, ${b64}`}
        /> : null}
    </Box>)
  )
}

export default QualityControlImageCrop;
